import { GetAllTinybirdEventsResponseBodyType } from "@intelligems/ig-types";
import { api } from "@src/api/api";
import { tinybirdEvents } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

const getSummaryMetrics = async () => {
  const resp = await api.get<GetAllTinybirdEventsResponseBodyType>(
    "/v2/analytics/summary-metrics"
  );
  return resp.data;
};

export const useGetSummaryMetrics = () => {
  return useQuery<any>({
    queryKey: tinybirdEvents.summaryMetrics,
    queryFn: async () => getSummaryMetrics(),
  });
};
